import * as angular from "angular";
import { ImportStatusService } from "../import-status/import-status.service";

export class FeatureToggleService {
    /* @ngInject */
    constructor(private importStatusService: ImportStatusService, private feature: {newExperience: boolean}) {}

    isNewExperience(districtId: string):angular.IPromise<boolean> {
        return this.importStatusService.getPilotStatus(districtId).then(httpCode => {
            return httpCode === 200 || this.feature.newExperience;
        });
    }    
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/feature-toggle/feature-toggle.service.ts